import { Component, Input } from '@angular/core';
import { ViewportService } from 'app/core/services/viewport.service';

@Component({
  selector: 'fts-order-notification-info-message',
  templateUrl: './order-notification-info-message.component.html',
  styleUrls: ['./order-notification-info-message.component.scss'],
})
export class OrderNotificationInfoMessageComponent {
  @Input()
  message: string;

  constructor(public viewportService: ViewportService) {}
}
